export default (theme) => {
  return {
    paragraphBlogContent: {
      '&:first-child > h2': {
        fontSize: '3rem',
      },
    },

    header: {
      marginTop: '2rem',
      marginBottom: '2rem',
    },

    subheader: {
      marginTop: '1rem',
      marginBottom: '1rem',
    },

    paragraph: {
      marginTop: '1rem',
      marginBottom: '1rem',
    },

    paragraphContent: {
      lineHeight: '2rem',
      whiteSpace: 'pre-line',
      '& iframe': {
        width: '100%',
      },
      '& blockquote': {
        fontSize: '1.4rem',
        margin: '2rem 3rem',
        display: 'inline-block',
        [theme.breakpoints.down('xs')]: {
          fontSize: '1.2rem',
          margin: '1rem',
        },
      },
    },
  }
}
